export const getWeekViewEntityData = (state) =>
  state.entityDataByView && state.entityDataByView.weekView
export const getWeekViewStartDay = (state) => state.weekViewStartDay
export const getWeekViewWidth = (state) => state.weekViewWidth
